export function timeFix () {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

export function downloadFile (file) {
  getFileBlob(file.url).then(blob => {
    let elink = document.createElement('a');
    elink.href = window.URL.createObjectURL(blob);
    elink.download = file.name;
    document.body.appendChild(elink);
    elink.click();
    window.URL.revokeObjectURL(elink.href) ;
    document.body.removeChild(elink);
  });
}

export function getFileBlob (url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}

export const scrollPage = vm => {
  const scrollTop = vm.$route.meta.scrollTop;
  if (scrollTop) {
    setTimeout(function(){
      window.scrollTo({top: scrollTop, behavior: 'instant'});
    }, 100)
  }
}